<template>
  <div v-show="showComponent">
    <v-row class="pa-10">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
            image
          </v-icon>
          {{ $t('common:media_plural') }}
        </h2>

        <DataTablePaginated
          ref="table"
          class="ma-1"
          :addTopScrollBar="isAdmin"
          :headerSet="isAdmin ? headers : []"
          :headers="isAdmin ? [] : headers"
          :expand="isAdmin"
          :expandFn="expandField"
          icon="edit"
          @clickedButton1="editAdvert"
          :iconTooltip="$t('buttons:edit')"
          :icon2="isAdmin ? 'file_download' : null"
          @clickedButton2="downloadCsv"
          :iconTooltip2="$t('display/advert:overview.download-csv')"
          :icon3="isAdmin ? 'picture_as_pdf' : null"
          @clickedButton3="generatePdfWindow"
          :iconTooltip3="$t('display/advert:overview.download-pdf')"
          icon4="delete"
          @clickedButton4="deleteAdvert"
          :iconTooltip4="$t('buttons:delete')"
          :icon5="'file_copy'"
          @clickedButton5="cloneAdvert"
          :iconTooltip5="$t('display/advert:overview.clone-advert')"
          @updateTableData="updateTable"
          :trueFalseDecorateFields="trueFalseDecorateFields"
          :decorateFields="decorateFields"
          :addBtn="true"
          :headButton="isAdmin"
          :headBtnText='$t("display/advert:overview.csv-to-pdf")'
          @clickedHeadButton="$refs.convertToPdf.$refs.input.click()"
          headButtonIcon="picture_as_pdf"
          @clickedAddButton="editAdvert"
          @updateHeaders="updateHeaders"
          :addBtnText="$t('buttons:add-specific', {specific: $t('common:media')})"
          image="image"
          imageAlt="building_thumbnail.png"
          sortBy="dateStart"
          :sortDesc="true"
          filterName="advert"
          :customPanel="createPanel()"
          @cacheCommit="$store.commit('display/advert/storeAdvertOverviewSearch', $event)"
        />

        <TwoButtonDialog
          ref="deleteButton"
          :dialog-title="$t('dialog:delete-btn-title', {name : $t('common:media')})"
          :dialog-text="$t('dialog:delete-btn-dialog', {name : $t('common:media')})"
          :button1-text="$t('buttons:cancel')"
          :button2-text="$t('buttons:delete')"
          :hideButton="true"
          @clickedButton1="$refs.deleteButton.showDialog = false"
          @clickedButton2="remove"
        />

        <TwoButtonDialog
          ref="generatePdf"
          :dialog-title="$t('display/advert:overview.dialog.pdf-title')"
          :dialog-text="$t('display/advert:overview.dialog.pdf-text')"
          :button1-text="$t('buttons:cancel')"
          :button2-text="$t('display/advert:overview.dialog.send')"
          :hideButton="true"
          @clickedButton1="$refs.generatePdf.showDialog = false"
          @clickedButton2="downloadPdf"
        />

        <v-file-input
          ref="convertToPdf"
          hide-input
          prepend-icon=""
          truncate-length="15"
          @change="uploadCsv"
          v-model="csvFile"
        ></v-file-input>

      </v-col>
    </v-row>

    <AdvertForm
      @updateTable="$refs.table.callTableUpdate()"
      ref="advertForm"
    />
  </div>
</template>

<script>
import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated'
import TablePanel from '@/modules/display/views/advert/overview/TablePanel';
import AdvertService from '@/modules/display/services/advert-service';
import DataUtils from '@/modules/core/services/data-utils';
import Advert from '@/modules/display/data/advert';
import Utils from '@/modules/core/services/utils';
import AdvertForm from '@/modules/display/views/advert/AdvertForm';
import UsersService from '@/modules/core/services/users-service';
import StatusField from '@/modules/display/views/advert/overview/StatusField';
import NameCompressionField from '@/modules/display/views/advert/overview/NameCompressionField';
import ButtonField from '@/modules/display/views/advert/overview/ButtonField';
import ExpandedField from '@/modules/display/views/advert/overview/ExpandedField';
import TwoButtonDialog from '@/modules/core/components/TwoButtonDialog/TwoButtonDialog';
import Vue from 'vue';
import {i18n} from '@/plugins/i18next';
import PdfService from '@/modules/display/services/pdf-service';
import {Role} from "@/modules/core/data/roles";

export default {
  name: 'AdvertOverview',
  components: {
    DataTablePaginated,
    TwoButtonDialog,
    AdvertForm,
  },
  data() {
    return {
      showComponent: false,
      userHeaders: [],
      currentAdvert: null,
      csvFile: {}
    }
  },
  watch: {
    overviewSearch(value) {
      if (this.cardView) {
        this.$refs.table.search = value;
      }
    }
  },
  computed: {
    decorateFields() {
      return [
          {name: 'status', method: this.decorateStatus},
          {name: 'buttonContent', method: this.decorateButtonContent},
          {name: 'name', method: this.decorateNameCompression}
      ]
    },
    trueFalseDecorateFields() {
      return this.isAdmin ? ['deleted', 'active'] : ['inPlaylist', 'active'];
    },
    headers() {
      return this.loadHeaders();
    },
    isAdmin() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes(Role.Admin);
      }
      return false;
    },
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  methods: {
    editAdvert(advertItem) {
      this.$refs.advertForm.initialize(advertItem);
    },
    editAdvertById(advertId) {
      this.$refs.advertForm.initializeById(advertId);
    },
    downloadCsv(advertItem) {
      AdvertService.downloadCsv(
        advertItem.id,
        (response) => {
          const blob = new Blob([response.data], { type: 'text/csv' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.download = advertItem.id + '.csv';
          link.click();
          URL.revokeObjectURL(link.href);
        }
      )
    },
    deleteAdvert(advertItem) {
      this.currentAdvert = advertItem;
      this.$refs.deleteButton.showDialog = true;
    },
    generatePdfWindow(advertItem) {
      this.currentAdvert = advertItem;
      this.$refs.generatePdf.showDialog = true;
    },
    remove() {
      AdvertService.removeOnAPI(
        this.currentAdvert.id,
        () => {
          Utils.showSuccessSnackbar(this.$t('snackbar:delete-success', {name: this.$t('common:media')}));
          this.$refs.table.callTableUpdate();
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:delete-failure', {name: this.$t('common:media')}));
        }
      );
      this.$refs.deleteButton.showDialog = false;
    },
    calculateCampaignDone(adverts) {
      adverts.forEach((advert) => {

        if (advert.budget === 0) {
          advert.campaignDone = '~';
          return;
        }

        if (advert.playedBudget === null || advert.playedBudget === 0) {
          advert.campaignDone = '0 %';
          return;
        }

        let finished = parseFloat(advert.playedBudget) / parseFloat(advert.budget);
        finished = finished * 100;
        finished = finished.toFixed(2)
        advert.campaignDone = finished + ' %';
      });
    },
    showMedia(adverts) {
      adverts.forEach((advert) => {
        advert.image = AdvertService.getThumbnailUrl(advert.id);
      });
    },
    updateTable(options, search, filter) {
      if (!search) search = '';

      if (options.sortBy[0]) {
        // there is no image field in the DB but media
        options.sortBy[0] = options.sortBy[0] === 'image' ? 'media' : options.sortBy[0];
      }

      this.$refs.table.loading = true;
      if (typeof filter === 'undefined') {
        this.searchTableUpdate(options, search);
      } else {
        this.filterTableUpdate(options, search, filter);
      }
    },
    filterTableUpdate(options, search, origFilter) {
      let filter = Object.assign({}, origFilter);

      AdvertService.readFilterPaginatedFromAPI(
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        AdvertService.updateFilterForSend(filter),
        (response) => {
          if (options.sortBy[0]) {
            // reverse replace
            options.sortBy[0] = options.sortBy[0] === 'media' ? 'image' : options.sortBy[0];
          }
          if (this.$refs.table !== undefined) {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Advert);
            this.calculateCampaignDone(response.data.content);
            this.showMedia(response.data.content);
            this.$refs.table.fillTableData(response.data);
          }
        },
        (error) => {
          this.$refs.table.loading = false;
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:media')}));
          this.$logger.error(error);
        }
      )
    },
    searchTableUpdate(options, search) {
      AdvertService.readAllPaginatedFromAPI(
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        (response) => {
          if (options.sortBy[0]) {
            // reverse replace
            options.sortBy[0] = options.sortBy[0] === 'media' ? 'image' : options.sortBy[0];
          }
          if (this.$refs.table !== undefined) {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Advert);
            this.calculateCampaignDone(response.data.content);
            this.showMedia(response.data.content);
            this.$refs.table.fillTableData(response.data);
          }
        },
        (error) => {
          this.$refs.table.loading = false;
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('common:media')}));
          this.$logger.error(error);
        }
      )
    },
    loadHeaders() {
      let defaultHeader = this.isAdmin
        ? require('./overview/advert-header').default.getHeader()
        : require('./overview/advert-header').default.getUserHeader() ;

      //Needs just for triggering, that language was changed.
      this.$t('');

      if (this.isSavedHeadersValid(this.userHeaders)) {
        for (let i = 0; i < defaultHeader.length; i++) {
          defaultHeader[i].default = this.userHeaders.indexOf(defaultHeader[i].value) >= 0;
        }
      }

      return defaultHeader;
    },
    updateHeaders(headers) {
      if (this.showComponent === true) {
        UsersService.saveAdvertHeader({columns: headers});
      }
    },
    isSavedHeadersValid(headers) {
      if (!Array.isArray(headers)) {
        return false;
      }

      if (headers.length <= 0) {
        return false;
      }

      for (let i = 0; i < headers.length; i++) {
        if (typeof headers[i] === 'string'
          && headers[i].length > 0
          && !this.isNumeric(headers[i])) {
          return true;
        }
      }

      return false;
    },
    isNumeric(str) {
      if (typeof str != "string") return false;
      return !isNaN(str) && !isNaN(parseFloat(str));
    },
    decorateStatus(item) {
      let StatusFieldComponent = Vue.extend(StatusField);
      let instance = new StatusFieldComponent({
        i18n,
        propsData: { item: item }
      });
      return instance;
    },
    decorateButtonContent(item) {
      let ButtonFieldComponent = Vue.extend(ButtonField);
      let instance = new ButtonFieldComponent({
        i18n,
        propsData: { item: item }
      });
      return instance;
    },
    decorateNameCompression(item) {
      let NameCompressionFieldComponent = Vue.extend(NameCompressionField);
      let instance = new NameCompressionFieldComponent({
        i18n,
        propsData: { item: item }
      });
      return instance;
    },
    expandField(item) {
      let ExpandedFieldComponent = Vue.extend(ExpandedField);
      let instance = new ExpandedFieldComponent({
        i18n,
        propsData: {
          item: item
        }
      })
      return instance;
    },
    downloadPdf() {
      this.$refs.generatePdf.setButtonSettings(false, true, true, false);
      AdvertService.sendPdfGenerationRequest(
        this.currentAdvert.id,
        (response) => {
          let pdfId = response.data.pdfFileId;
          this.checkIfPdfGenerated(pdfId);
        },
        () => {
          this.$refs.generatePdf.showDialog = false;
          this.$refs.generatePdf.setButtonSettings(false, false, false, false);
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/advert:overview.pdf')}));
        }
      );
    },
    checkIfPdfGenerated(pdfDocumentId) {
      PdfService.sendPdfCheckStatusRequest(
        pdfDocumentId,
        (response) => {
          if (response.status == 202) {
            this.checkIfPdfGenerated(pdfDocumentId);
          } else {
            this.$refs.generatePdf.showDialog = false;
            this.$refs.generatePdf.setButtonSettings(false, false, false, false);
            this.downloadGeneratedPdf(pdfDocumentId);
          }
        },
        () => {
          this.$refs.generatePdf.showDialog = false;
          this.$refs.generatePdf.setButtonSettings(false, false, false, false);
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/advert:overview.pdf')}));
        }
      )
    },
    downloadGeneratedPdf(pdfDocumentId) {
      PdfService.downloadPdf(
        pdfDocumentId,
        (pdfFile) => {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(pdfFile);
          link.download = pdfDocumentId + '.pdf';
          link.click();
          URL.revokeObjectURL(link.href);
        }
      )
    },
    uploadCsv() {
      if(!this.csvFile) return;

      AdvertService.uploadCsvFile(
        this.csvFile,
        (response) => {
          let pdfId = response.data.pdfFileId;
          this.checkIfPdfGenerated(pdfId);
        },
        () => {
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/advert:overview.pdf')}));
        }
      );
    },
    createPanel() {
      let TablePanelComponent = Vue.extend(TablePanel);
      let instance = new TablePanelComponent({
        i18n
      });

      instance.$on('reloadTable', this.callUpdate);
      return instance;
    },
    callUpdate() {
      this.$refs.table.callTableUpdate();
    },
    cloneAdvert(advert) {
      if (!advert || !advert.id) return;

      AdvertService.cloneById(
          advert.id,
          () => {
            Utils.showSuccessSnackbar(this.$t('snackbar:clone-success', {name: advert.name}));
            this.callUpdate();
          },
          () => {
            Utils.showFailureSnackbar(this.$t('snackbar:clone-failure', {name: advert.name}));
          }
      )
    }
  },
  created() {
    UsersService.getAdvertHeader(
      (response) => {
        this.userHeaders = response.data;
        this.loadHeaders();
        this.showComponent = true;
      }
    )
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(to.query.advert) {
        vm.editAdvertById(to.query.advert)
        vm.$router.replace(`/${vm.$store.state.manager.displayModuleUrl}/advert`);
      }
    });
  },
}
</script>

<style lang="scss">

</style>
